var map = {
	"./bg_prize.png": 198,
	"./bg_top.png": 193,
	"./lb.png": 197,
	"./ll.png": 199,
	"./lr.png": 200,
	"./lt.png": 196,
	"./p1.png": 417,
	"./p2.png": 418,
	"./p3.png": 419,
	"./p4.png": 420,
	"./p_main.png": 421,
	"./r1.png": 422,
	"./r2.png": 423,
	"./r3.png": 424,
	"./r4.png": 425,
	"./t-xs.png": 195,
	"./t.png": 194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 250;